// extracted by mini-css-extract-plugin
export default {"ctnMare":"Footer_ctnMare__YSCYe","ctnGrid":"Footer_ctnGrid__cvg3b","copyright":"Footer_copyright__9Az4j","linkFooter":"Footer_linkFooter__VvSTT"};